import { IComboBoxOption } from "@fluentui/react";
interface IApiConfig {
  schieAPIBaseURL: string;
}
interface IMsalConfig {
  auth: {
    clientId: string;
    authority: string;
    redirectUri: string;
    postLogoutRedirectUri: string;
  };
  cache: {
    cacheLocation: string;
    storeAuthStateInCookie: boolean;
  };
}

interface IAuthConfig {
  authScopeRequests: {
    scopes: string[];
  };
}
interface IFooterDetails {
  prefix: string;
  href: string;
  text: string;
}
interface IAppSettings {
  DEFAULT_PAGE_SIZE: number;
  API_CONFIG: IApiConfig;
  MSAL_CONFIG: IMsalConfig;
  AUTH_CONFIG: IAuthConfig;
  ACTION_PERMISSION: { [key: string]: any };
  MENU_ITEM_PERMISSION: { [key: string]: any };
  LAB_INVENTORY_ALL_TOOLS: IComboBoxOption[];
  USER_ACTIVITY_TYPES: IComboBoxOption[];
  LAB_INVENTORY_TOOLS: IComboBoxOption[];
  LAB_INVENTORY_PROPERTY: IComboBoxOption[];
  LEASE_ACTIONS: string[];
  ALL_LEASE_ACTIONS: IComboBoxOption[];
  LEASE_STATUS: IComboBoxOption[];
  IS_ACTIVE: IComboBoxOption[];
  HISTORY_STATUS: IComboBoxOption[];
  TERM_OPTIONS: IComboBoxOption[];
  CM_ELEVATION_OPTIONS: IComboBoxOption[];
  RM_ELEVATION_OPTIONS: IComboBoxOption[];
  RACK_MODEL_OPTIONS: IComboBoxOption[];
  RACK_MANAGER_OPTIONS: IComboBoxOption[];
  RACK_HEIGHT_OPTIONS: IComboBoxOption[];
  SPACE_TYPE: IComboBoxOption[];
  RACK_USE: IComboBoxOption[];
  RACK_WEIGHT_OPTIONS: IComboBoxOption[];
  RACK_STATUS_TYPE: IComboBoxOption[];
  RM_STATES_OPTIONS: IComboBoxOption[];
  CURRENT_DEPLOYED_OPTIONS: IComboBoxOption[];
  INFRA_DEVICE_TYPE_OPTIONS: IComboBoxOption[];
  JBOD_JBOF: IComboBoxOption[];
  PDU_TYPE: IComboBoxOption[];
  LOCATION: IComboBoxOption[];
  BLADE_STATE: IComboBoxOption[];
  BLADE_LEASE: IComboBoxOption[];
  RESET_TYPE: IComboBoxOption[];
  ADO_URL: string;
  SKU_GENERATION_OPTIONS: IComboBoxOption[];
  SKU_PROCESSOR_OPTIONS: IComboBoxOption[];
  BAASRAAS_LEASE_OPTIONS: IComboBoxOption[];
  FOOTER_LINKS: Array<IFooterDetails>;
  REQUEST_PERMISSION_LINK: string;
  ACTIONS: IComboBoxOption[];
  LABINVENTORY_INFO_ACTIONS: IComboBoxOption[];
}
export const APP_SETTINGS: IAppSettings = {
  DEFAULT_PAGE_SIZE: 50,
  API_CONFIG: {
    schieAPIBaseURL: process.env.REACT_APP_API_ROOT_URL || "",
  },
  MSAL_CONFIG: {
    auth: {
      clientId:
        process.env.REACT_APP_AAD_APP_ID !== undefined
          ? process.env.REACT_APP_AAD_APP_ID
          : "",
      authority: `${process.env.REACT_APP_MS_LOGIN_URL}/${process.env.REACT_APP_TENANT_ID}`,
      redirectUri: "/",
      postLogoutRedirectUri: "/",
    },
    cache: {
      cacheLocation: "localStorage",
      storeAuthStateInCookie: true,
    },
  },
  AUTH_CONFIG: {
    authScopeRequests: {
      scopes: [`api://${process.env.REACT_APP_AAD_API_APP_ID}/User.Read`],
    },
  },
  ACTION_PERMISSION: {
    AddDatacenter: ["LabManager", "LabEngRW", "SooperTrooper"],
    EditDatacenter: ["LabManager", "LabEngRW", "SooperTrooper"],
    ExportDatacenter: ["LabManager", "LabEngRW", "LabEngRO", "SooperTrooper"],
    AddRack: ["LabManager", "LabEngRW", "SooperTrooper"],
    EditRack: ["LabManager", "LabEngRW", "SooperTrooper"],
    DeleteRack: ["LabManager", "SooperTrooper"],
    AddInfraDevice: ["LabManager", "LabEngRW", "SooperTrooper"],
    EditInfraDevice: ["LabManager", "LabEngRW", "SooperTrooper"],
    DeleteInfraDevice: ["LabManager", "LabEngRW", "SooperTrooper"],
    AddLabInventoryCategory: ["LabManager", "LabEngRW", "SooperTrooper"],
    EditLabInventoryCategory: ["LabManager", "LabEngRW", "SooperTrooper"],
    DeleteLabInventoryCategory: ["LabManager", "LabEngRW", "SooperTrooper"],
    AddLabInventoryType: ["LabManager", "SooperTrooper"],
    EditLabInventoryType: ["LabManager", "SooperTrooper"],
    DeleteLabInventoryType: ["LabManager", "SooperTrooper"],
    AddLabInventoryStatus: ["LabManager", "SooperTrooper"],
    EditInventoryStatus: ["LabManager", "SooperTrooper"],
    DeleteInventoryStatus: ["LabManager", "SooperTrooper"],
    AddLabInventoryBundle: ["LabManager", "SooperTrooper"],
    EditLabInventoryBundle: ["LabManager", "SooperTrooper"],
    DeleteLabInventoryBundle: ["LabManager", "SooperTrooper"],
    AddPowerlimit: ["LabManager", "SooperTrooper"],
    EditPowerlimit: ["LabManager", "SooperTrooper"],
    DeletePowerlimit: ["LabManager", "SooperTrooper"],
    AddSWLicensePackage: ["LabManager", "SooperTrooper"],
    EditSWLicensePackage: ["LabManager", "SooperTrooper"],
    DeleteSWLicensePackage: ["LabManager", "SooperTrooper"],
    AddSecurityGroup: ["LabManager", "SooperTrooper"],
    EditSecurityGroup: ["LabManager", "SooperTrooper"],
    DeleteSecurityGroup: ["LabManager", "SooperTrooper"],
    AddCorsica: ["LabManager", "LabEngRW", "SooperTrooper"],
    EditCorsica: ["LabManager", "LabEngRW", "SooperTrooper"],
    LabInventory: ["LabManager", "LabEngRW", "SooperTrooper"],
    AddRackManager: ["LabManager", "LabEngRW", "SooperTrooper"],
    EditRackManager: ["LabManager", "LabEngRW", "SooperTrooper"],
    DeleteRackManager: ["LabManager", "SooperTrooper"],
    AddChassisManager: ["LabManager", "LabEngRW", "SooperTrooper"],
    EditChassisManager: ["LabManager", "LabEngRW", "SooperTrooper"],
    DeleteChassisManager: ["LabManager", "SooperTrooper"],
    AddLabInventoryProject: ["LabManager", "SooperTrooper"],
    EditLabInventoryProject: ["LabManager", "SooperTrooper"],
    DeleteLabInventoryProject: ["LabManager", "SooperTrooper"],
    AddLabInventory: ["LabManager", "SooperTrooper"],
    EditLabInventory: ["LabManager", "SooperTrooper"],
    DeleteLabInventory: ["LabManager", "SooperTrooper"],
    RestoreLabInventory: ["LabManager", "LabEngRW", "SooperTrooper"],
    LeaseLabInventory: ["LabManager", "LabEngRW", "SooperTrooper"],
    ManageraApprovalLabInventory: ["LabManager", "SooperTrooper"],
    AddServiceContract: ["LabManager", "SooperTrooper"],
    EditServiceContract: ["LabManager", "SooperTrooper"],
    DeleteServiceContract: ["LabManager", "SooperTrooper"],
    DetailJbod: ["LabManager", "LabEngRW", "SooperTrooper"],
    LogJbod: ["LabManager", "LabEngRW", "SooperTrooper"],
    AddPdu: ["LabManager", "LabEngRW", "SooperTrooper"],
    EditPdu: ["LabManager", "LabEngRW", "SooperTrooper"],
    DeletePdu: ["LabManager", "SooperTrooper"],
    AllLeases: ["LabManager", "LabEngRW", "SooperTrooper"],
    MyLeases: ["LabManager", "LabEngRW", "SooperTrooper"],
    checkin: ["LabManager", "LabEngRW", "SooperTrooper"],
    extend: ["LabManager", "LabEngRW", "SooperTrooper"],
    cutpower: ["LabManager", "SooperTrooper"],
    restorepower: ["LabManager", "SooperTrooper"],
    BAASRAASReservationRequestAdd: ["LabManager", "LabEngRW", "SooperTrooper"],
    BAASRAASReservationRequestClose: ["LabManager", "SooperTrooper"],
    BAASRAASCheckOut: ["LabManager", "SooperTrooper"],
    BAASRAASCheckInExtend: ["LabManager", "SooperTrooper"],
    BAASRAASCheckInExtendInSG: ["LabEngRW"],
    BAASRAASTransfer: ["LabManager", "SooperTrooper"],
    BAASRAASValidate: ["LabManager", "SooperTrooper"],
    BaasRaasBenchReservation: ["LabManager", "LabEngRW", "SooperTrooper"],
    SustainingCheckIn: ["LabManager", "SooperTrooper"],
    SustainingCheckout: ["LabManager", "LabEngRW", "SooperTrooper"],
    SustainingEdit: ["LabManager", "LabEngRW", "SooperTrooper"],
    SustainingAdd: ["LabManager", "LabEngRW", "SooperTrooper"],
    AddSite: ["LabManager", "SooperTrooper"],
    EditSite: ["LabManager", "SooperTrooper"],
    DeleteSite: ["LabManager", "SooperTrooper"],
    AddBuilding: ["LabManager", "SooperTrooper"],
    EditBuilding: ["LabManager", "SooperTrooper"],
    DeleteBuilding: ["LabManager", "SooperTrooper"],
    AddManufacturerName: ["LabManager", "SooperTrooper"],
    EditManufacturerName: ["LabManager", "SooperTrooper"],
    DeleteManufacturerName: ["LabManager", "SooperTrooper"],
    AddUser: ["SooperTrooper"],
    LabInventoryAudit: ["SooperTrooper"],
    LabInventoryLeaseAudit: ["SooperTrooper"],
    RackAudit: ["SooperTrooper"],
    User: ["SooperTrooper"],
  },
  MENU_ITEM_PERMISSION: {
    AdminLink: ["LabManager", "SooperTrooper"],
    AllLeases: ["LabManager", "LabEngRW", "SooperTrooper"],
    MyLeases: ["LabManager", "LabEngRW", "SooperTrooper"],
    AuditLink: ["SooperTrooper"],
    AdminUserLink: ["SooperTrooper"],
    PowerBILink1: ["LabManager", "LabEngRW", "SooperTrooper"],
  },
  LAB_INVENTORY_ALL_TOOLS: [
    { text: "Taiwan", key: 1 },
    { text: "IMT", key: 2 },
    { text: "IS&T", key: 3 },
    { text: "SCHIE Lab", key: 4 },
    { text: "IMS", key: 5 },
    { text: "SLAM", key: 6 },
  ],
  LAB_INVENTORY_TOOLS: [
    { text: "IMT", key: 2 },
    { text: "IS&T", key: 3 },
    { text: "SCHIE Lab", key: 4 },
    { text: "SLAM", key: 6 },
  ],
  LAB_INVENTORY_PROPERTY: [
    { text: "Microsoft", key: "Microsoft" },
    { text: "Third Party", key: "Third Party" },
  ],
  LEASE_ACTIONS: ["CheckIn", "Extend", "Transfer"],
  ALL_LEASE_ACTIONS: [
    { text: "Check In | Extend | Transfer", key: "In Use" },
    { text: "Check Out", key: "Available" },
    { text: "Validate", key: "Pending" },
  ],
  LEASE_STATUS: [
    { text: "Pending", key: "Pending" },
    { text: "Available", key: "Available" },
    { text: "In Use", key: "In Use" },
  ],
  IS_ACTIVE: [
    { text: "Yes", key: "true" },
    { text: "No", key: "false" },
  ],
  USER_ACTIVITY_TYPES: [
    { text: "Aggregated Page Hits", key: "aggregate" },
    { text: "Individualized Page Hits", key: "individual" },
  ],
  HISTORY_STATUS: [
    { text: "Expired", key: 0 },
    { text: "Current", key: 1 },
  ],
  TERM_OPTIONS: [
    { text: "Subscription", key: "Subscription" },
    { text: "Maintenance agreement", key: "Maintenance agreement" },
    { text: "Perpetual licenses", key: "Perpetual licenses" },
    { text: "NODE_LOCKED", key: "NODE_LOCKED" },
  ],
  CM_ELEVATION_OPTIONS: [
    { text: "C1", key: "C1" },
    { text: "C2", key: "C2" },
    { text: "C3", key: "C3" },
  ],
  RM_ELEVATION_OPTIONS: [
    { text: "RM1", key: "RM1" },
    { text: "RM2", key: "RM2" },
    { text: "RM3", key: "RM3" },
    { text: "RM4", key: "RM4" },
  ],
  RACK_MODEL_OPTIONS: [
    { text: "Rack", key: "Rack" },
    { text: "Rack Manager", key: "Rack Manager" },
    { text: "RM", key: "RM" },
    { text: "R-SCM", key: "R-SCM" },
    { text: "CM", key: "CM" },
    { text: "Shelf", key: "Shelf" },
    { text: "StandAlone", key: "StandAlone" },
    { text: "BAAS", key: "BAAS" },
    { text: "RAAS", key: "RAAS" },
    { text: "PILLAR", key: "PILLAR" },
    { text: "Networking", key: "Networking" },
    { text: "Locker", key: "Locker" },
    { text: "Bench", key: "Bench" },
    { text: "Sidekick", key: "Sidekick" },
    { text: "Chiller", key: "Chiller" },
  ],
  RACK_MANAGER_OPTIONS: [
    { text: "Bench", key: "Bench" },
    { text: "Sidekick", key: "Sidekick" },
    { text: "Chiller", key: "Chiller" },
    { text: "CM", key: "CM" },
    { text: "Locker", key: "Locker" },
    { text: "Networking", key: "Networking" },
    { text: "PILLAR", key: "PILLAR" },
    { text: "RM", key: "RM" },
    { text: "R-SCM", key: "R-SCM" },
    { text: "Shelf", key: "Shelf" },
    { text: "StandAlone", key: "StandAlone" },
  ],
  RACK_HEIGHT_OPTIONS: [
    { text: "None", key: "None" },
    { text: "12U", key: "12U" },
    { text: "42U", key: "42U" },
    { text: "44U", key: "44U" },
    { text: "48U", key: "48U" },
    { text: "52U", key: "52U" },
  ],
  RACK_WEIGHT_OPTIONS: [
    { text: "None", key: "None" },
    { text: "2,000lbs/6sqft", key: "2,000lbs/6sqft" }
  ],
  SPACE_TYPE: [
    { text: "Rack", key: "Rack" },
    { text: "Bench", key: "Bench" },
    { text: "Pillar", key: "Pillar" },
    { text: "Locker", key: "Locker" },
    { text: "Storage", key: "Storage" },
    { text: "HVAC", key: "HVAC" }
  ],
  RACK_USE: [
    { text: "Engineering", key: "Engineering" },
    { text: "RAAS", key: "RAAS" },
    { text: "BAAS", key: "BAAS" },
    { text: "Networking", key: "Networking" },
    { text: "Infrastructure", key: "Infrastructure" },
    { text: "Logistics", key: "Logistics" }
  ],
  RACK_STATUS_TYPE: [
    { text: "Reserved", key: "Reserved" },
    { text: "Deployed", key: "Deployed" },
    { text: "Deployment in Progress", key: "Deployment in Progress" },
    { text: "Decommission", key: "Decommission" },
    { text: "Scream Test", key: "Scream Test" },
    { text: "Audit", key: "Audit" },
    { text: "Future", key: "Future" }
  ],
  RM_STATES_OPTIONS: [
    { text: "Working", key: "Working" },
    { text: "Failure", key: "Failure" },
    { text: "NoNetwork", key: "NoNetwork" },
    { text: "Private IP", key: "Private IP" },
    { text: "Time Out", key: "TimeOut" },
    { text: "Failed to Retrieve Info", key: "FailedToRetrieveInfo" },
  ],
  CURRENT_DEPLOYED_OPTIONS: [
    { text: "1", key: 1 },
    { text: "0", key: 0 },
  ],
  INFRA_DEVICE_TYPE_OPTIONS: [
    { text: "Management Switch", key: "Management Switch" },
    { text: "Network Switch", key: "Network Switch" },
    { text: "KVM", key: "KVM" },
    { text: "Other", key: "Other" },
  ],
  JBOD_JBOF: [
    { text: "JBOD", key: "JBOD" },
    { text: "JBOF", key: "JBOF" },
  ],
  PDU_TYPE: [
    { text: "PDU", key: "PDU" },
    { text: "PMDU", key: "PMDU" },
  ],
  LOCATION: [
    { text: "USA", key: "USA" },
    { text: "TAIWAN", key: "TAIWAN" },
    { text: "INDIA", key: "INDIA" },
  ],
  BLADE_STATE: [
    { text: "Working", key: "Working" },
    { text: "WinRMFailure", key: "WinRMFailure" },
    { text: "NoDHCPEntry", key: "NoDHCPEntry" },
    { text: "NoMAC", key: "NoMAC" },
    { text: "Failure", key: "Failure" },
    { text: "NoNetwork", key: "NoNetwork" },
  ],
  RESET_TYPE: [
    { key: "type", text: "Select Reset Type" },
    { key: "On", text: "On" },
    { key: "ForceOff", text: "ForceOff" },
    { key: "GracefulShutdown", text: "GracefulShutdown" },
    { key: "GracefulRestart", text: "GracefulRestart" },
    { key: "ForceRestart", text: "ForceRestart" },
    { key: "ForceOn", text: "ForceOn" },
  ],
  BLADE_LEASE: [
    { key: "action", text: "Select Action" },
    { key: "edit", text: "Edit" },
    { key: "checkin", text: "Checkin" },
    { key: "extend", text: "Extend" },
    { key: "transfer", text: "Transfer" },
  ],
  ADO_URL: "https://dev.azure.com/CHIELabs/CHIE%20Labs",
  SKU_GENERATION_OPTIONS: [
    { text: "Gen8.1", key: "Gen8.1" },
    { text: "Gen8.0", key: "Gen8.0" },
    { text: "Gen7.5", key: "Gen7.5" },
    { text: "Gen7.3", key: "Gen7.3" },
    { text: "Gen7.2", key: "Gen7.2" },
    { text: "Gen7.1", key: "Gen7.1" },
    { text: "Gen7.0", key: "Gen7.0" },
    { text: "Gen6.3", key: "Gen6.3" },
    { text: "Gen6.2", key: "Gen6.2" },
    { text: "Gen6.1", key: "Gen6.1" },
    { text: "Gen5.8", key: "Gen5.8" },
    { text: "Gen5.4", key: "Gen5.4" },
    { text: "Gen5.2", key: "Gen5.2" },
    { text: "Gen5.1", key: "Gen5.1" },
    { text: "Gen5.0", key: "Gen5.0" },
  ],
  SKU_PROCESSOR_OPTIONS: [
    { text: "AMD", key: "AMD" },
    { text: "Intel", key: "Intel" },
  ],
  BAASRAAS_LEASE_OPTIONS: [
    { text: "Checkout", key: "Checkout" },
    { text: "CheckIn,Extend,Transfer", key: "CheckIn,Extend,Transfer" },
    { text: "Validate", key: "Validate" },
  ],
  LABINVENTORY_INFO_ACTIONS : [
    { key: "Added", text: "Added"},
    { key: "Updated", text: "Updated"},
    { key: "Deleted", text: "Deleted"}
  ],
  ACTIONS : [
    { key: "Added", text: "Added"},
    { key: "Updated", text: "Updated"}
  ],
  FOOTER_LINKS: [
    {
      prefix: "Explore",
      href: "https://microsoft.sharepoint.com/sites/SCHIELabPortal/SitePages/SCHIE-Labs-Wiki.aspx",
      text: "SCHIE Lab",
    },
    {
      prefix: "Stay Updated! Join",
      href: "https://idwebelements.microsoft.com/GroupManagement.aspx?Group=SCHIE%20Lab%20Ticket%20Access%20-%20Redmond&Operation=join",
      text: "SCHIE Lab Notification",
    },
    {
      prefix: "Need help? Contact",
      href: "mailto:csiirldev@microsoft.com",
      text: "CHIE Team",
    },
  ],
  REQUEST_PERMISSION_LINK:
    "https://dev.azure.com/CHIELabs/CHIE%20Labs/_wiki/wikis/CHIE-Labs.wiki/393/Accessing-the-Lab-Portal-System",
};

export const options = [
  { key: "disks", text: "Disks" },
  { key: "dimms", text: "Dimms" },
  { key: "nics", text: "Nics" },
  { key: "procs", text: "Procs" },
  { key: "fpgas", text: "FPGAs" },
];

